export const NotificationDataUrl = () => '/ClubLink/GetCustomerSms';
